import {SALES_DETAIL_TYPE_KEY_TYPE} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	id: z.string().nullable(),
	type: SALES_DETAIL_TYPE_KEY_TYPE,
	content: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const SalesManagementDetailResModel = {schema, model};
export type ISalesManagementDetailResModel = z.infer<typeof SalesManagementDetailResModel.model>;
export const DEFAULT_SALES_MANAGEMENT_DETAIL_RES: ISalesManagementDetailResModel = {
	id: null,
	type: "LAST_WEEK_ACTION_REPORT",
	content: ""
};
